module.exports = __webpack_public_path__ + "media/new_message.aa8bc76b.ogg";